import hasServices, { IHasServices } from "@/model/mixins/Service/hasServices"
import hasServicesSelected, { IHasServicesSelected } from "@/model/mixins/Service/hasServicesSelected"
import hasServiceFamilyContent, { IHasServiceFamilyContent } from "@/model/mixins/Content/hasServiceFamilyContent"
import hasServiceFamilyConfig, { IHasServiceFamilyConfig } from "@/model/mixins/Config/hasServiceFamilyConfig"

class ServiceFamilyBase {
    private id: string

    constructor(
        id: string,
    ) {
        this.id = id
    }

    public getId(): string {
        return this.id
    }

}

export interface IServiceFamily extends ServiceFamilyBase, IHasServices, IHasServicesSelected, IHasServiceFamilyContent, IHasServiceFamilyConfig {
    getId(): string
}

// apply mixin
const ServiceFamily: Constructor<IServiceFamily> = hasServicesSelected(hasServiceFamilyConfig(hasServiceFamilyContent(hasServices(ServiceFamilyBase))))

export default ServiceFamily